module.exports = __webpack_public_path__ + "static/logo-ce568dfd494b649eb16a2a6d4fe2220c.png";